import 'preact/debug'; // debug must be first import in whole app
import App from './components/App';

export default App;
